<template lang="pug">
  .b2b-page-add-parties-service
    transition(name="fade" mode="out-in")
          b2b-page-add-parties-services()
</template>

<script>
import B2bPageAddPartiesServices from '@/views/administracion/empresas/B2bPageAddPartiesServices'

export default {
  name: 'b2b-page-add-parties-service',
  components: {
    B2bPageAddPartiesServices
  }
}
</script>

<style lang="scss" scoped>

</style>
